module.exports = __webpack_public_path__ + "static/img/instant2.9bdc215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/instant2.png
// module id = 9I88
// module chunks = 1